// extracted by mini-css-extract-plugin
export default {"headline":"P09Wc4yGLp_2nj1jkSzA","points":"kH2E950UgjJWADe3qatC"};